import React, { Component } from 'react';
import { Backdrop, Spinner } from 'components';
import { logger } from 'helpers';
import { PatientClose, PatientRefresh } from 'components/Icons';

import s from './style.module.scss';

const blockScroll = (nextProps, props) => {
	const body = document.querySelectorAll('body')[0];
	const rootEl = document.getElementById('root');

	if (nextProps.show && props.show !== nextProps.show) {
		body.style.overflow = 'hidden';

		if (rootEl.offsetHeight > window.innerHeight)
			rootEl.style.overflow = 'scroll';
	} else if (!nextProps.show && props.show !== nextProps.show) {
		body.style.overflow = 'auto';

		if (rootEl.offsetHeight > window.innerHeight)
			rootEl.style.overflow = 'auto';
	}
};

class PatientModal extends Component {
	componentDidUpdate(prevProps) {
		logger('[PatientModal] componentDidUpdate');

		blockScroll(this.props, prevProps);
	}

	render() {
		const wrapClasses = [s.wrapper, this.props.wrapClassName];
		const modalClasses = [s.modal, this.props.className];
		let modal = <Spinner className={s.spinner} />;
		let refresh;

		if (this.props.show) {
			wrapClasses.push(s.open);
		}

		if (this.props.modalRefresh) {
			refresh = (
				<PatientRefresh
					className={s.refreshBtn}
					onClick={this.props.modalRefresh}
				/>
			);
		}

		if (!this.props.loading) {
			modal = (
				<div className={modalClasses.join(' ')}>
					<span className={s.modal_title}>{this.props.modalTitle}</span>
					{refresh}
					{!this.props.restrictClosing ? (
						<>
							<PatientClose
								className={s.closeBtn}
								onClick={this.props.modalClosed}
							/>
							<div className={s.title_tab_separator}></div>
						</>
					) : (
						''
					)}
					{this.props.children}
				</div>
			);
		}

		return (
			<Backdrop
				show={this.props.show}
				clicked={
					!this.props.restrictClosing ? this.props.modalClosed : () => false
				}
			>
				{modal}
			</Backdrop>
		);
	}
}

PatientModal.defaultProps = {
	modalRefresh: false,
};

export default PatientModal;
